import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

const areas = [
  { city: 'Wellesley', note: 'Our Home Base' },
  { city: 'Boston', note: 'Metro Area' },
  { city: 'Cambridge', note: 'Metro Area' },
  { city: 'Newton', note: 'Metro Area' },
  { city: 'Brookline', note: 'Metro Area' },
  { city: 'Needham', note: 'Metro Area' },
  { city: 'Weston', note: 'Metro Area' },
  { city: 'Natick', note: 'MetroWest' },
  { city: 'Framingham', note: 'MetroWest' },
  { city: 'Worcester', note: 'Central MA' },
];

const ServiceAreasPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero */}
      <section className="relative h-[60vh] min-h-[420px] flex items-center justify-center overflow-hidden">
        <img
          src="https://public.readdy.ai/ai/img_res/64fdede1669afccc261a48a2b0040422.jpg"
          alt="Service Areas"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-gray-900/85 to-gray-900/50"></div>
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <p className="text-[#C4A962] font-semibold tracking-widest uppercase text-sm mb-4">Custom Clothiers</p>
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">Service Areas</h1>
          <p className="text-xl text-gray-200 max-w-2xl mx-auto">
            Based in Wellesley, MA — we serve all of Massachusetts and New England with in-store and house call appointments.
          </p>
        </div>
      </section>

      {/* House Calls Banner */}
      <section className="bg-[#C4A962] py-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 flex items-center justify-center bg-white/20 rounded-full">
              <i className="ri-car-line text-white text-2xl"></i>
            </div>
            <div>
              <p className="text-white font-bold text-lg">We Come to You</p>
              <p className="text-white/80 text-sm">We make house and office calls throughout Massachusetts and New England.</p>
            </div>
          </div>
          <a href="tel:781-237-3166" className="bg-white text-[#C4A962] px-8 py-3 rounded-lg font-bold hover:bg-gray-100 transition-colors whitespace-nowrap">
            <i className="ri-phone-line mr-2"></i>Call to Schedule
          </a>
        </div>
      </section>

      {/* Service Description */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">We Serve All of Massachusetts and New England</h2>
          <p className="text-lg text-gray-600 leading-relaxed mb-8">
            Custom Clothiers proudly serves clients throughout Massachusetts and the entire New England region. Whether you visit our Wellesley showroom or prefer the convenience of a house or office call, we bring 55+ years of bespoke tailoring expertise directly to you.
          </p>
          <p className="text-lg text-gray-600 leading-relaxed">
            Our traveling consultants bring fabric samples, take precise measurements, and provide personalized styling guidance at your location — making custom tailoring more accessible than ever.
          </p>
        </div>
      </section>

      {/* Sample Cities */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-14">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Sample Cities We Serve</h2>
            <p className="text-lg text-gray-500 max-w-2xl mx-auto">
              These are just a few of the many communities we serve across Massachusetts
            </p>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6">
            {areas.map((area) => (
              <div key={area.city} className="bg-gray-50 rounded-xl p-6 text-center hover:bg-[#C4A962]/10 transition-colors border border-gray-100">
                <div className="w-10 h-10 bg-[#C4A962]/10 rounded-full flex items-center justify-center mx-auto mb-3">
                  <i className="ri-map-pin-2-fill text-[#C4A962] text-xl"></i>
                </div>
                <h3 className="font-bold text-gray-900 mb-1">{area.city}</h3>
                <p className="text-xs text-gray-500">{area.note}</p>
              </div>
            ))}
          </div>
          <div className="text-center mt-12">
            <p className="text-gray-600 text-lg mb-4">Don't see your city listed?</p>
            <p className="text-gray-500">We serve the entire Massachusetts and New England region. Call us to confirm service in your area.</p>
          </div>
        </div>
      </section>

      {/* Map */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-14">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Visit Our Wellesley Showroom</h2>
            <p className="text-lg text-gray-500">326A Washington St, Wellesley, MA 02481</p>
          </div>
          <div className="rounded-2xl overflow-hidden shadow-xl h-96">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d11801.994221273937!2d-71.2760006!3d42.310564!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89e3815826935e15%3A0xcaf824c3ab79e6a1!2sCustom%20Clothiers!5e0!3m2!1sen!2sus!4v1711556553393!5m2!1sen!2sus"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Custom Clothiers Location"
            ></iframe>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-10">
            <div className="text-center">
              <div className="w-12 h-12 flex items-center justify-center bg-[#C4A962]/10 rounded-xl mx-auto mb-4">
                <i className="ri-map-pin-line text-[#C4A962] text-2xl"></i>
              </div>
              <h3 className="font-bold text-gray-900 mb-1">Address</h3>
              <p className="text-gray-500 text-sm">326A Washington St<br />Wellesley, MA 02481</p>
            </div>
            <div className="text-center">
              <div className="w-12 h-12 flex items-center justify-center bg-[#C4A962]/10 rounded-xl mx-auto mb-4">
                <i className="ri-phone-line text-[#C4A962] text-2xl"></i>
              </div>
              <h3 className="font-bold text-gray-900 mb-1">Phone</h3>
              <a href="tel:781-237-3166" className="text-gray-500 text-sm hover:text-[#C4A962] transition-colors">781-237-3166</a>
            </div>
            <div className="text-center">
              <div className="w-12 h-12 flex items-center justify-center bg-[#C4A962]/10 rounded-xl mx-auto mb-4">
                <i className="ri-time-line text-[#C4A962] text-2xl"></i>
              </div>
              <h3 className="font-bold text-gray-900 mb-1">Hours</h3>
              <p className="text-gray-500 text-sm">Mon–Fri: 8AM–5PM<br />Sat: 8AM–4PM</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 bg-gray-900 text-white">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h2 className="text-4xl font-bold mb-4">Ready to Get Started?</h2>
          <p className="text-gray-400 text-lg mb-8">Call us today to schedule your appointment — whether at our showroom or your location.</p>
          <div className="flex flex-wrap justify-center gap-4">
            <a href="tel:781-237-3166" className="bg-[#C4A962] text-white px-8 py-4 rounded-lg font-bold hover:bg-[#B39952] transition-colors whitespace-nowrap">
              <i className="ri-phone-line mr-2"></i>Call 781-237-3166
            </a>
            <Link to="/contact" className="border-2 border-white text-white px-8 py-4 rounded-lg font-bold hover:bg-white/10 transition-colors whitespace-nowrap">
              Call for Appointment
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ServiceAreasPage;